module.exports = "<div class=q-marg-all-xl> This order has updated to a status which prohibits any editing to the order moving forward. No changes you've made will be saved to this order. </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/editSubmissionFailModalBody.html
// module id = 1361
// module chunks = 1